module.exports = __webpack_public_path__ + "static/media/case-studies.6b8862d0.png";